// =============================================================================
// ui/shell/FilterBar.tsx — the toolbar: the Filters button and the active chips.
// -----------------------------------------------------------------------------
// Assembled here rather than in AppShell so the shell keeps its promise of
// owning no data: it takes a `toolbar` node and knows nothing about filters.
//
// The facet universe is loaded here, at the one place that needs it, and passed
// down — so a tab never pays for it and the drawer never triggers a read on open.
// =============================================================================

import { FilterChips } from './FilterChips';
import { FilterDrawer } from './FilterDrawer';
import { useFacetUniverse } from '../state/useFacetUniverse';
import type { FacetTrade } from '../../selectors/accounts';

export function FilterBar({ tabId }: { tabId?: string | undefined }) {
  const { rows } = useFacetUniverse();
  return (
    <>
      <FilterDrawer universe={(rows as readonly FacetTrade[] | null) ?? null} tabId={tabId} />
      <FilterChips />
    </>
  );
}
